<template lang="pug">
#folding_forming
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_folding_forming.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_folding_forming_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 Fold Molding
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 The semi-finished product of the box sheet that has been processed by printing, glazing, die-cutting, etc., is glued, folded, and glued according to the molding requirements of the box body to make a box body that can be used for packaging.
  section#product_profile
    b-row.menu
      b-col.text-center.position-relative.active PVC
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p This product has good transparency and gloss, light water ripples, and good printability. It is suitable for box packaging of toys, gifts, clothing, cosmetics and food. It can fully display the characteristics of the packaged material and achieve the effect of display and display.
          div
            h3 
              span Product Features
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span Product Information
            ol
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span PVC Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_2
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC Fold Molding-NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC has good transparency and gloss, light water ripples, and good printability. It is suitable for box packaging of toys, gifts, clothing, cosmetics and food. There are no heating type, need heating type, etc.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, PVC, Fold Molding, No heating, Need heating' },
            { name: 'og:title', content: 'PVC Fold Molding-NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'PVC has good transparency and gloss, light water ripples, and good printability. It is suitable for box packaging of toys, gifts, clothing, cosmetics and food. There are no heating type, need heating type, etc.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'Fold Molding',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/processing_Desktop/folding_forming_img_01.jpg',
            img_alt: 'Nan Ya Rigid PVC has good transparency and gloss, light water ripples, good printability, and is suitable for folding into various packaging boxes.' },
          { 
            id: '2',
            img_src: 'img/processing_Desktop/folding_forming_img_02.jpg',
            img_alt: 'Nan Ya Rigid PVC has good transparency and gloss, light water ripples, good printability, and is suitable for folding into various packaging boxes.' },
          { 
            id: '3',
            img_src: 'img/processing_Desktop/folding_forming_img_03.jpg',
            img_alt: 'Nan Ya Rigid PVC has good transparency and gloss, light water ripples, good printability, and is suitable for folding into various packaging boxes.' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: 'This product can meet the needs of folding processing, and adopts a special formula to prevent whitening and fast bonding during folding.' },
          { message: 'Meet the requirements of EU REACH and ROHS regulations.' },
          { message: 'Good transparency and gloss, light water ripple and good printability.' },
          { message: 'According to customer needs, products with anti-ultraviolet and high impact resistance can be produced.' }
        ],
        p_use: [
          { message: 'Customizable items: tanning, corona, cold resistance, temperature resistance, weather resistance, flame resistance, antistatic and anti-fog, etc.' },
          { message: 'Inspection specifications: ASTM D-1593, ASTM D-792, JIS-K6734, etc.' }
        ],
        p_specification: [
          { 
            id: '1',
            name: 'VBBB(No Heating Type)',
            feature: 'Features: Good transparency, high gloss, light water ripple, good printability',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub>：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub>：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub>：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">Unregulated</span>',
            vcm: 'VCM<sub>(ppm)</sub>：Unregulated' },
          { 
            id: '2',
            name: 'VBBF(Need Heating Type)',
            feature: 'Features: Good transparency, high gloss, light water ripple, good printability',
            outward: 'Appearance: Transparent, colored, shiny, matte',
            thickness: 'Thickness<sub>(mm)</sub> ：0.25',
            proportion: 'S.G.<sub>(g/cm3)</sub> ：1.35±3%',
            pull: 'Tensile Strength<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: 'Elongation<sub>(%)</sub> ：<br/><span class="pl-5">MD>135/CD>90</span>',
            heating: 'Heat Shrinkage<sub>(%,150°CX10min)</sub>：<br/><span class="pl-5">Unregulated</span>',
            vcm: 'VCM(ppm)</sub>：Unregulated' },
        ],
        swiperOption_pvc: {
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            790: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Vacuum Molding',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/processing_Desktop/other_pic_pro_1.jpg',
            href_link: 'vacuum_forming'
          },
          {
            id:'3',
            name:'Heat Sealing',
            text:'Dielectric heat sealing for high frenquency heat sealing application.target as plastics staged between high electrodes sheet. Subject be fusioned and heat sealing with suitable temperature.',
            url:'./img/processing_Desktop/other_pic_pro_3.jpg',
            href_link: 'heat_seal'
          },
          {
            id:'4',
            name:'Printing',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process',
            url:'./img/processing_Desktop/other_pic_pro_4.jpg',
            href_link: 'print'
          },
          {
            id:'5',
            name:'Metalize',
            text:'Under vacuum conditions, a metal element is deposited on the surface  by steam or sputtering. In this way, a very thin coating on surface can be obtained, and it has the outstanding advantages of fast speed and good adhesion.',
            url:'./img/processing_Desktop/other_pic_pro_5.jpg',
            href_link: 'plating'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#folding_forming
  #specification
    background-image: url(../assets/bg/bg_folding_forming.jpg)


</style>
